import { render, staticRenderFns } from "./contentBannerDelete.vue?vue&type=template&id=2418405d&"
import script from "./contentBannerDelete.vue?vue&type=script&lang=js&"
export * from "./contentBannerDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports